













import { OElement } from '../element';
import Vue from 'vue';

export default Vue.extend({
  name: 'OButton',
  components: {
    OElement,
  },
  props: {
    isChive: Boolean,
    isRedOnion: Boolean,
  },
});
